import React from 'react'
import { DataSuspense } from '@ztechapps/webui.util'
import { TableProvider, useTableContext } from './Context'
import { DefaultTableStats } from './table-stats/DefaultTableStats'
import { Layout } from './Layout'
import { Stack } from 'react-bootstrap'
import styles from './datatable.module.scss'
import type { TableProviderProps } from './types'

export type DataTableProps<T = any> = Omit<TableProviderProps<T>, 'children'>

/**
 * This component shows the table with error, loading and empty content
 * This is the basic layout of the table
 */
export function DataTable<T = any>(props: DataTableProps<T>) {
  return (
    <TableProvider {...props}>
      <DataTableLayout />
    </TableProvider>
  )
}

export const DataTableLayout = () => {
  const context = useTableContext()
  const { components, listResult, tableOptions, dataSuspenseOptions } = context

  //intentionally ignore the loading, we show it using the stats
  return (
    <DataSuspense {...dataSuspenseOptions} error={listResult?.error}>
      <Stack className={styles.tableStack}>
        <Layout {...tableOptions}>
          <components.tableHead />
          <components.tableBody />
          <components.tableFoot />
        </Layout>
        <div className="flex-shrink-0">
          <DefaultTableStats />
        </div>
      </Stack>
    </DataSuspense>
  )
}
